module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bOyAy"))).then(() => parcelRequire('hEqeo'));